import React from 'react';
import { Link } from 'react-router-dom';

import { Application } from 'entities/application/types';
import { ApplicationStatus } from 'entities/application/ui/ApplicationStatus/ApplicationStatus';
import {
	CardDescriptionStyled,
	CardHeaderStyled,
	CardStyled,
	CardTextContainerStyled,
	LogoCoverStyled,
} from './ApplicationsListItem.styles';

type ApplicationsListItemProps = {
	application: Application;
};

export const ApplicationsListItem: React.FC<ApplicationsListItemProps> = ({ application }) => (
	<Link to={`/${application.id}`} style={{ maxWidth: `282px` }}>
		<CardStyled
			hoverable
			cover={
				<LogoCoverStyled style={{ backgroundImage: `url(${application.logoBgr})` }}>
					<img
						style={{ height: `120px`, width: `120px` }}
						alt={`Логотип приложения ${application.name}`}
						src={application.logoUrl}
					/>
					<div style={{ position: `absolute`, top: `12px`, right: `12px` }}>
						{application.status && <ApplicationStatus status={application.status} />}
					</div>
				</LogoCoverStyled>
			}
		>
			<CardTextContainerStyled>
				<CardHeaderStyled>{application.shortName ? application.shortName : application.name}</CardHeaderStyled>
				<CardDescriptionStyled>
					{application.descriptionCard?.split(`.`)[0] ?? application.description.split(`.`)[0]}
				</CardDescriptionStyled>
			</CardTextContainerStyled>
		</CardStyled>
	</Link>
);
